import { api } from '@/utils/api';

export const useCreateReminderMutation = () => {
  const utils = api.useUtils();
  return api.reminderAction.create.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.reminderAction.all.invalidate(),
        utils.reminderAction.id.invalidate(),
      ]);
    },
  });
};

export const useDeleteReminderMutation = () => {
  const utils = api.useUtils();
  return api.reminderAction.delete.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.reminderAction.all.invalidate(),
        utils.reminderAction.id.invalidate(),
        utils.team.all.invalidate(),
        utils.team.id.invalidate(),
        utils.user.me.invalidate(),
      ]);
    },
  });
};

export const useUpdateReminderMutation = () => {
  const utils = api.useUtils();
  return api.reminderAction.update.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.reminderAction.all.invalidate(),
        utils.reminderAction.id.invalidate(),
        utils.team.all.invalidate(),
        utils.team.id.invalidate(),
        utils.user.me.invalidate(),
      ]);
    },
  });
};

export const useSetDefaultReminderMutation = () => {
  const utils = api.useUtils();
  return api.reminderAction.setDefault.useMutation({
    onSuccess: async () => {
      await Promise.all([
        utils.reminderAction.all.invalidate(),
        utils.reminderAction.id.invalidate(),
        utils.team.all.invalidate(),
        utils.team.id.invalidate(),
        utils.user.me.invalidate(),
      ]);
    },
  });
};
